export class CompanyCollectiveInvoiceSetting {
	public id: number;
	public companyId: string;
	public isActive: boolean;
	public parentCharge: number;
	public subAgentCharge: number;
	public invoiceDayOfMonth: number;
	public invoiceEmail: string;

	constructor(setting?: CompanyCollectiveInvoiceSetting) {
		Object.assign(this, setting);
	}
}
